import type { TextStyle } from 'react-native';
import { StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCheckoutSummaryStyleDefs = {
  checkoutSummaryRailSticky: {
    borderTopColor: ticketColors.ruleSoft,
  },

  checkoutSummaryRailEmbedded: {
    gap: spacing.sm,
    paddingTop: spacing.xs,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
  },

  checkoutFooterTotals: {
    gap: spacing.xs,
  },

  checkoutMpQrFooterPanel: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
    padding: spacing.sm,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
  },

  checkoutMpQrFooterIconWrap: {
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
    flexShrink: 0,
  },

  checkoutMpQrFooterText: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },

  checkoutMpQrFooterTitle: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },

  checkoutMpQrFooterBody: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
    fontFamily: ticketFonts.sans,
  },

  checkoutSummarySection: {
    gap: spacing.xs,
  },

  checkoutDiffRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },

  checkoutDiffLabel: {
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },

  checkoutDiffValue: {
    fontSize: 22,
    lineHeight: 26,
    fontWeight: '700',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    letterSpacing: -0.4,
    fontFamily: ticketFonts.mono,
  },

  checkoutDiffValueOk: {
    color: ticketColors.ok,
  },

  checkoutDiffValueWarn: {
    color: ticketColors.gold,
  },

  checkoutActions: {
    paddingTop: spacing.md,
    marginTop: spacing.sm,
    alignSelf: 'stretch',
  },

  summaryHintFooter: {
    ...typography.caption,
    fontSize: 10,
    color: ticketColors.ink2,
    marginTop: 4,
    lineHeight: 13,
    fontFamily: ticketFonts.sans,
  },

  checkoutFooterPrimaryButton: {
    alignSelf: 'stretch',
    width: '100%',
    minHeight: 48,
  },

  checkoutFooterPrimaryButtonText: {
    fontSize: 16,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },

  checkoutPromoSummaryBlock: {
    marginTop: spacing.sm,
    paddingTop: spacing.sm,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    gap: spacing.xs,
  },

  checkoutPromoSummaryRow: {
    gap: 0,
  },

  summaryHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    marginTop: spacing.xs,
    fontFamily: ticketFonts.sans,
  },
} as const;
